import { Container } from 'flux/utils';
import ActivityActions from './../actions/ActivityActions';
import ActivityStore from 'payments/stores/ActivityStore';
import ActivityTransactionsTable from 'payments/components/ActivityTransactionsTable.jsx';
import ActivityTransactionsTableNux from 'payments/components/ActivityTransactionsTableNux.jsx';
import Activity from 'entities/Activity';
import React, { Component, PropTypes } from 'react';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';

class ActivityTransactionsTableContainer extends Component {
  static propTypes = {
    activity: PropTypes.instanceOf(Activity).isRequired,
  }

  static getStores() {
    return [ActivityStore];
  }

  static calculateState(state, props) {
    return {
      loading: state ? state.loading : true,
      activity: ActivityStore.getActivityById(props.activity.id),
      transactions: ActivityStore.getTransactionsForActivityUUID(props.activity.id),
    };
  }

  componentDidMount() {
    ActivityActions.getTransactions(this.props.activity.id).then(
      () => this.setState({ loading: false })
    );
  }

  render() {
    if (this.state.loading && this.state.transactions.length === 0) {
      return <CenteredLoadingIndicator />;
    }

    if (!this.state.loading && this.state.transactions.length === 0) {
      return (
        <ActivityTransactionsTableNux
          isFree={this.state.activity.isFree()}
          isClosed={this.state.activity.isClosed()}
          activityURL={this.state.activity.getPayUrl()}
        />
      );
    }

    return <ActivityTransactionsTable transactions={this.state.transactions} />;
  }
}

export default Container.create(ActivityTransactionsTableContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/containers/ActivityTransactionsTableContainer.jsx